import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { ConferenceResponse } from "~types/conference.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
  enabled?: boolean;
};

export const useFetchConferenceList = ({ customParams, enabled = true }: Props) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["conferences", sport, organizationId, customParams],
    enabled,
    queryFn: () =>
      request<ConferenceResponse>(`${sport}/o/${organizationId}/conferences?${params.toString()}`).then((response) =>
        transformListResponse(response),
      ),
  });
};
